import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Placeholder from "@/pages/Placeholder";
import Services from "@/pages/Services";
import ACRepair from "@/pages/services/ACRepair";
import Maintenance from "@/pages/services/Maintenance";
import Replacement from "@/pages/services/Replacement";
import IndoorAirQuality from "@/pages/services/IndoorAirQuality";
import About from "@/pages/About";
import ServiceAreas from "@/pages/ServiceAreas";
import Demo from "@/pages/Demo";
import DemoLeads from "@/pages/DemoLeads";
import ServiceRequest from "@/pages/ServiceRequest";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/ac-repair" element={<ACRepair />} />
            <Route path="/services/maintenance" element={<Maintenance />} />
            <Route path="/services/replacement" element={<Replacement />} />
            <Route
              path="/services/indoor-air-quality"
              element={<IndoorAirQuality />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/demo/leads" element={<DemoLeads />} />
            <Route path="/request-service" element={<ServiceRequest />} />
            <Route
              path="*"
              element={
                <Placeholder
                  title="Page not found"
                  subtitle="This page hasn't been built yet — but the rest of the demo lives back on the homepage."
                  ctaLabel="Return Home"
                  ctaHref="/"
                />
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
